module.exports = __webpack_public_path__ + "img/photo-61.7e6e1f03.webp";